const autoNgTemplateLoaderTemplate1 = require('./createSecret.html');

angular.module('portainer.kubernetes').component('kubernetesCreateSecretView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesCreateSecretController',
  controllerAs: 'ctrl',
});
